import React from 'react';
import { StoryCategory, StoryObject } from '@benzinga/advanced-news-manager';
import { News } from '@benzinga/basic-news-manager';
import { isSponsoredArticle } from '@benzinga/article-manager/sponsored-utils';
import { PostCard, PostCardLayout, PostCardSize } from './PostCard';
import { formatImageUrl } from '@benzinga/utils';

interface NewsCardProps {
  contentId?: string;
  layout?: PostCardLayout;
  node: StoryObject | News;
  size?: PostCardSize;
}

export const NewsCard: React.FC<NewsCardProps> = ({ contentId, layout = 'default', node, size = 'default' }) => {
  const isSponsored = isSponsoredArticle(node);
  const dataAction = contentId ? `${contentId} Article Click` : 'Article Click';
  return (
    <div className="news-card">
      <PostCard
        dataAction={dataAction}
        description={node.teaser ?? ''}
        id={node.id}
        image={formatImageUrl(node)}
        imageWidth={400}
        layout={layout}
        size={size}
        sponsored={isSponsored}
        stocks={node.stocks as StoryCategory[]}
        title={node.title ?? ''}
        url={node.url}
      />
    </div>
  );
};
